import React, { useState } from "react"

import PageWrapper from "WebVisual/PageWrapper"
import PodcastList from "WebVisual/Components/PodcastList"

const Podcast = () => {
  const [search, setSearch] = useState("")

  return (
    <PageWrapper onChange={setSearch} title="Podcast">
      <PodcastList search={search} />
    </PageWrapper>
  )
}

export default Podcast
